import React from "react";
import { takeLatest, put, all } from "redux-saga/effects";
import { toast } from "react-toastify";
import history from "../../../services/history";
import { isMobile, getPath, getSessionStorageKey, setSessionStorageKey, redirectTo } from "../../../utils";

import HttpService from "../../../services/HttpService";

import {
	changeLoading,
	changeCreatedStatus,
	onboardValidatingEmailResponse,
	verifyDuplicityEmailResp,
	getResponseUpdateOnboardField,
	loginByOnboardGogogoRequest,
	updatedAllFields,
	sendingToMarket,
	responseTicket,
	sendTicketLoading,
} from "./actions";
import { setDataLoginRequest } from "../sessionStorage/actions";
import { isVerifyingDuplicityEmail, setGogogoStatus, setLoading } from "../onboardSimple/actions";
import { triggerAdjustEvent } from "../../../index";
import config from "../../../config/ConfigApplication";
import { handleAdjustEventRequest } from "../adjust/action";
import { generatePathToLogin } from "../../../utils/generateRedirectLoginPath";
import { Button } from "react-bootstrap";
import { logoutAndLoginForced } from "../auth/actions";

let counterLogin = 0;
export function* onboardingGogogo({ payload }) {
	const { password, isTermAccepted, event, tokenRecaptchaRegister, adid } = payload;
	try {
		yield put(changeLoading(true));

		const response = yield HttpService.onboardGogogo(password, isTermAccepted);

		if (
			response.success &&
			response.result &&
			response.result.cd_auth_token.length &&
			response.result.id_investor > 0
		) {
			yield put(loginByOnboardGogogoRequest(password, event, tokenRecaptchaRegister, adid));
		}

		if (
			response.result &&
			!response.result.onboard_completed &&
			response.result.error_message.length &&
			response.result.id_investor <= 0
		) {
			yield put(changeLoading(false));
			throw response.result;
		}

		if (
			response.result &&
			response.result.code &&
			!["CPF_ALREADY_USED", "RNE_ALREADY_USED"].includes(response.result.code)
		) {
			yield put(sendingToMarket(true));
			yield put(changeLoading(false));
			const socialLoginInfo = JSON.parse(localStorage.getItem("INFO_USER_LOGIN"));

			if (socialLoginInfo) {
				const { email, id, idSocial } = socialLoginInfo;
				const cdAccessToken = sessionStorage.getItem("cd_access_token");
				const resp = yield HttpService.associateSocialAccount(
					cdAccessToken,
					email,
					id,
					idSocial
				);

				if (resp.success) sessionStorage.removeItem("cd_access_token");
			}

			history.push(redirectTo());
			throw response.result;
		}

		if (
			(response.success &&
				["CPF_ALREADY_USED", "RNE_ALREADY_USED"].includes(response.result.code)) ||
			["EMAIL_ALREADY_IN_USE"].includes(response.code)
		) {
			yield put(changeLoading(false));
			const changeRouter = () => {
				let appflow = localStorage.getItem("appflow");
				if (appflow == "REGISTER") localStorage.setItem("appflow", "RECOVER");
				history.push("/onboard/welcome-register");
				HttpService.setAbandonedOnboardStatus();
				sessionStorage.setItem("IS_ABANDONADED", true);
			};
			// REVER
			const message = () => (
				<div>
					<span>
						{" "}
						Ops! 🤔 Identificamos que você já está cadastrado no
						TradeMap,&nbsp;
						<Button
							variant="link"
							style={{
								padding: "0",
								textDecoration: "underline",
								fontWeight: "bold",
								color: "#FFF",
							}}
							onClick={() => changeRouter()}
						>
							clique aqui
						</Button>
						<br />
						para <strong>recuperar sua senha.</strong>
					</span>
				</div>
			);
			toast.error(message, { autoClose: 30000 });
		}

		if (!response.success) throw response;
	} catch (err) {
		let message =
			err.message ||
			err.error_message ||
			"Não foi possível salvar seus dados. Por gentileza tente novamente.";
		if (
			err &&
			err.message &&
			["512", "COMPLETED"].some((word) =>
				String(err.message).toLocaleUpperCase().includes(word.toLocaleUpperCase())
			)
		) {
			yield put(loginByOnboardGogogoRequest(password, event, tokenRecaptchaRegister, adid));
			return;
		}

		yield put(changeLoading(false));
		toast.error(message);
		console.error("ONBOARD_GOGOGO_ERROR", err);
	}
}

export function* loginByOnboardGogogo({ payload }) {
	try {
		const { password, event, tokenRecaptchaRegister, adid: idAdjust } = payload;
		const username = sessionStorage.getItem("DOC_TEMP");

		payload.cpf = username;

		const response = yield HttpService.login(
			username,
			password,
			tokenRecaptchaRegister ? tokenRecaptchaRegister : {}
		);

		if (!response.success) throw response;

		const param = {
			...JSON.parse(sessionStorage.getItem("DATA_TERM")),
			ip: yield HttpService.getRegionIp(),
		};

		if (sessionStorage.getItem("DATA_TERM")) sessionStorage.removeItem("DATA_TERM");

		var pathNext = "";
		var redirectExternal = false;

		if (response.success) {
			triggerEventAtCheckout(true);
			if (event) yield HttpService.saveOnboardEvent(event);
			yield HttpService.approveTerms(param);

			sessionStorage.removeItem("DOC_TEMP");
			sessionStorage.setItem(
				"CLIENT_AUTH",
				JSON.stringify({ token: response.result.investor.token })
			);
			const typeFriend = localStorage.getItem("TYPE_FRIEND");

			if (typeFriend && typeFriend === "NEW_FRIEND") {
				const nickname = localStorage.getItem("NICKNAME");
				yield HttpService.setInvestorMGM(nickname);
			}

			const { investor, multiBroker, billingStatus } = response.result;
			yield put(setDataLoginRequest(investor, multiBroker, billingStatus));

			const idInfluencerLink = localStorage.getItem("FLUX_INFLUENCER");

			if (idInfluencerLink) {
				yield put(
					handleAdjustEventRequest({
						signupStage: "",
						loginData: response.result,
						idAdjust,
						idInfluencerLink,
					})
				);
				return;
			}

			if (localStorage.getItem("CACHEDPLAN")) {
				localStorage.removeItem("CACHEDPLAN");
				triggerEventAtCheckout();
				window.location.href = getPath("/onboarding/carrinho/plano");
				return;
			}

			if (!response.result && !response.result.is_user_recovered) {
				triggerAdjustEvent("z2pbs5", `${investor.id_investor}`);
			}

			if (
				billingStatus.id_plan !== 0 &&
				billingStatus.has_premium_subscription_permission &&
				billingStatus.is_last_payment_active &&
				billingStatus.cd_status !== "FREE"
			) {
				if (billingStatus.cd_status === "OPEN" || billingStatus.cd_status === "TRIAL") {
					if (isMobile.any()) {
						history.push("/onboard/redirecionar-loja");
						return;
					} else {
						const token = getSessionStorageKey("TOKEN");

						window.location.href = getPath(generatePathToLogin(token));
						return;
					}
				} else if (billingStatus.cd_status === "PROC") {
					pathNext = "/onboard/processando";
				}
			} else {
				if (localStorage.getItem("flow-market-place")) {
					toast.success("Dados salvos com sucesso.");
					localStorage.removeItem("flow-market-place");
					const plan = getSessionStorageKey("PLANSELECTED");
					pathNext = `/onboard/market-place-details/${plan.cd_product}`;
				} else if (localStorage.getItem("flow-checkout")) {
					localStorage.removeItem("flow-checkout");
					triggerEventAtCheckout();
					pathNext = "/onboarding/carrinho/combo";
					redirectExternal = true;
				} else if (localStorage.getItem("flow-feature")) {
					toast.success("Dados salvos com sucesso.");
					localStorage.removeItem("flow-feature");
					pathNext = "/onboard/checkout-details/feature";
				} else if (
					sessionStorage.getItem("CREATING_BY") &&
					sessionStorage.getItem("CREATING_BY").includes("EducaMap")
				) {
					window.location.href = `//${config.educaRedirect}/login`;
					sessionStorage.removeItem("CREATING_BY");
					return;
				}
				// REVER
				// else if (sessionStorage.getItem('COURSE')) {
				//   yield put(loginAuthentication(response.result.investor.token));
				//   return sessionStorage.removeItem('COURSE');
				// }
				else {
					if (isMobile.any()) {
						history.push("/onboard/redirecionar-loja");
						return;
					}
					return (window.location.href = getPath(
						generatePathToLogin(investor.token)
					));
				}
			}
			yield put(changeLoading(false));
		}

		if (!!pathNext && !redirectExternal) {
			history.push(pathNext);
		} else if (!!pathNext && redirectExternal) {
			triggerEventAtCheckout();
			window.location.href = getPath("/onboarding/carrinho/combo");
		}

		if (!response.success) throw response;
	} catch (error) {
		console.error("ERROR_LOGIN", error);

		if (error && ["INTERNAL_SERVER_ERROR"].includes(error.code) && counterLogin <= 1) {
			counterLogin++;

			const { cpf, password, tokenRecaptchaRegister, adid: idAdjust } = payload;

			yield put(
				logoutAndLoginForced({
					reason: "Logout forçado após erro interno na API do login",
					newLogin: {
						cpf,
						password,
						isProAuth: false,
						options: false,
						toMarket: false,
						tokenRecaptcha: tokenRecaptchaRegister
							? tokenRecaptchaRegister
							: {},
						idAdjust,
					},
					isLoginAfterOnboarding: true,
				})
			);

			return;
		}

		toast.success("Conta criada! Agora é só entrar e aproveitar ;)");

		yield put(changeLoading(false));
		setTimeout(() => {
			history.push(redirectTo());
		}, 2000);
	}
}

export function* updateOnboardField({ payload }) {
	try {
		const { field, _value, extra, is_edition } = payload;
		let value = _value;
		if (field === "vl_birthdate") {
			value = _value.split("/");
			value = value[2] + value[1] + value[0];
		}
		const response = yield HttpService.updateOnboardField(field, value, extra, is_edition);
		yield put(getResponseUpdateOnboardField(response));
		yield put(onboardValidatingEmailResponse(response));
	} catch (err) {
		let message = err.message || "Não foi possível salvar seus dados. Por gentileza tente novamente.";
		toast.error(message);
	}
}

function serializeInfoToParam(info) {
	let param = {};
	param.vl_fullname = info.name;
	param.vl_phone_number = info.phone;
	param.vl_document = info.cnpj_cpf;
	param.vl_email = info.emai;
	param.vl_country_code = 0;
	param.vl_birthdate = 0;
	param.cd_document_type = info.doc;
	param.is_phone_verified = false;
	param.create_session = true;
	return param;
}

export function* newInvestor({ payload }) {
	try {
		const { info } = payload;
		if (!info) throw Error({});
		let param = serializeInfoToParam(info);
		let resp = yield HttpService.newInvestor(param);
		if (resp.success) {
			yield put(changeCreatedStatus("CREATED"));
		} else {
			yield put(changeCreatedStatus("ERROR"));
		}
	} catch (err) {
		yield put(changeCreatedStatus("ERROR"));
		let message = err.message || "Não foi possível salvar seus dados. Por gentileza tente novamente.";
		toast.error(message);
	}
}

export function* onboardingGogogoStep({ payload }) {
	try {
		const { password, isTermAccepted, isEduca } = payload;
		yield put(changeLoading(true));
		const response = yield HttpService.onboardGogogo(password, isTermAccepted);

		if (
			(response.success && response.result.code !== "") ||
			(response.result.error_message.length && !response.result.onboard_completed)
		) {
			const message = response.result.error_message;
			toast.error(message);
			yield put(changeLoading(false));
			return;
		}

		if (!response.success) {
			toast.error(response.message);
			yield put(changeLoading(false));
			return;
		}

		if (!isEduca) {
			yield put(setLoading(true));
		}

		yield put(loginByOnboardGogogoRequest(password));
		yield put(setLoading(false));
		yield put(setGogogoStatus(response));
	} catch (error) {
		yield put(changeLoading(false));
		yield put(setGogogoStatus(error));
	}
}

export function* validatingEmail({ payload }) {
	yield put(isVerifyingDuplicityEmail(true));
	try {
		const { email, cpfInvestor } = payload;
		const response = yield HttpService.verifyDuplicityInEmail(email, cpfInvestor);
		if (!response || !response.success) {
			yield put(isVerifyingDuplicityEmail(false));
			yield put(verifyDuplicityEmailResp(false));
			toast.error(
				"Ocorreu um erro ao verificar a duplicidade do e-mail, por favor tente novamente.",
				{ autoClose: 5000 }
			);
			return;
		}
		yield put(isVerifyingDuplicityEmail(false));
		yield put(verifyDuplicityEmailResp(response));
	} catch (error) {
		toast.error("Ocorreu um erro ao verificar a duplicidade do e-mail, por favor tente novamente.", {
			autoClose: 5000,
		});
	}
}

export function* initialOnboarding() {
	try {
		let infoUserLogin = JSON.parse(localStorage.getItem("INFO_USER_LOGIN"));
		let idSocial = 0;

		if (infoUserLogin) {
			idSocial = infoUserLogin.idSocial;
		}
		const resp = yield HttpService.initialOnboard(idSocial);

		if (!resp.success) {
			throw resp;
		}

		sessionStorage.setItem("cd_access_token", resp.result.cd_access_token);
		localStorage.setItem("cd_access_token", resp.result.cd_access_token);
	} catch (error) {
		const message = error.message || "Tente novamente mais tarde";
		toast.error(message);
	}
}

export function* validateInitialOnboarding({ payload }) {
	const { cd_access_token, header } = payload;
	try {
		yield put(changeLoading(true));
		const resp = yield HttpService.validateInitialOnboard(cd_access_token, header);

		if (!resp.success) {
			throw resp;
		}

		history.push("/onboard/confirma-fone");
		yield put(changeLoading(false));
	} catch (error) {
		yield put(changeLoading(false));
		const message = error.message || "Tente novamente mais tarde";
		toast.error(message);
	}
}

export function* updateOnboardFields({ payload }) {
	try {
		const { fields } = payload;
		const { name, email, cnpj_cpf, vl_birthdate } = fields;

		let value = vl_birthdate;
		if (vl_birthdate) {
			value = value.split("/");
			value = value[2] + value[1] + value[0];
		}

		const responseName = yield HttpService.updateOnboardField("name", name, false);
		const responseEmail = yield HttpService.updateOnboardField("email", email, false);
		const responseDoc = yield HttpService.updateOnboardField("cnpj_cpf", cnpj_cpf, "CPF");
		const responseBirthDate = yield HttpService.updateOnboardField("vl_birthdate", value, false);

		if (
			responseName.success &&
			responseName.result &&
			responseEmail.success &&
			responseEmail.result &&
			responseDoc.success &&
			responseDoc.result &&
			responseBirthDate.success &&
			responseBirthDate.result
		) {
			yield put(getResponseUpdateOnboardField(responseBirthDate));
			yield put(onboardValidatingEmailResponse(responseEmail));
			yield put(updatedAllFields(true));
		}
	} catch (err) {
		let message = err.message || "Não foi possível salvar seus dados. Por gentileza tente novamente.";
		toast.error(message);
	}
}

export function* ticketZendesk({ payload }) {
	try {
		const resp = yield HttpService.ticketZendesk(payload);

		yield put(sendTicketLoading(true));
		if (!resp || !resp.success) throw resp;

		yield put(responseTicket(true));

		toast.success("Seu chamado foi aberto, em breve nossos analistas entrará em contato com você", {
			autoClose: 10000,
		});
	} catch (error) {
		console.error("[TICKET ZENDESK ERROR]", error);

		const sendForSupport = () => {
			window.open(
				`https://api.whatsapp.com/send?phone=5511943824762&text="Estou%20com%20problema%20para%20recuperar%20a%20minha%20senha.%20Pode%20me%20ajudar?`,
				"_blank"
			);
		};

		const message = () => (
			<div>
				<span>
					Houver um erro ao enviar o seu ticket, tente novamente mais tarde
					ou&nbsp;
					<Button
						variant="link"
						style={{
							padding: "0",
							textDecoration: "underline",
							fontWeight: "bold",
							color: "#FFF",
						}}
						onClick={() => sendForSupport()}
					>
						fale com a gente
					</Button>
					&nbsp;pelo WhatsApp, vamos te ajudar!
				</span>
			</div>
		);

		toast.error(message);
	} finally {
		yield put(sendTicketLoading(false));
	}
}

export default all([
	takeLatest("@register/ONBOARDING_NEW_INVESTOR", newInvestor),
	takeLatest("@register/ONBOARDING_GOGOGO_REQUEST", onboardingGogogo),
	takeLatest("@register/UPDATE_ONBOARD_FIELD_REQUEST", updateOnboardField),
	takeLatest("@register/ONBOARDING_GOGOGO_REQUEST_STEP", onboardingGogogoStep),
	takeLatest("@register/VALIDATING_EMAIL", validatingEmail),
	takeLatest("@register/INITIAL_ONBOARDING", initialOnboarding),
	takeLatest("@register/VALIDATE_INITIAL_ONBOARDING", validateInitialOnboarding),
	takeLatest("@register/LOGIN_BY_ONBOARD_GOGOGO", loginByOnboardGogogo),
	takeLatest("@register/UPDATE_ONBOARD_FIELDS_REQUEST", updateOnboardFields),
	takeLatest("@register/TICKET_ZENDESK_REQUEST", ticketZendesk),
]);

function triggerEventAtCheckout(withLogin = false) {
	setSessionStorageKey("TRIGGER_EVENT_AT_CHECKOUT", {
		isTriggerEvent: true,
		fluxUser: "NEW_REGISTER",
		isIncludesEventLogin: withLogin,
	});
}
